/**
 * File d'attente Firestore : sendAccountApprovalRequestEmail notifie admin@rentalyzer.ca.
 */
import { collection, addDoc } from 'firebase/firestore';
import { firestore } from '../config/firebase';

const COLLECTION = 'accountApprovalEmails';

/**
 * @param {{
 *   uid: string,
 *   email: string,
 *   persona: string,
 *   companyName?: string,
 *   phone?: string,
 *   personalAddressStreet?: string,
 *   personalAddressCity?: string,
 *   personalAddressProvince?: string,
 *   personalAddressPostalCode?: string,
 *   personalAddressCountry?: string,
 *   displayName?: string,
 *   locale?: 'fr' | 'en',
 * }} payload
 */
export async function queueAccountApprovalEmail(payload) {
  const uid = String(payload.uid || '').trim();
  const email = String(payload.email || '').trim().toLowerCase();
  if (!uid || !email) throw new Error('uid and email required');

  await addDoc(collection(firestore, COLLECTION), {
    uid,
    email,
    persona: payload.persona || '',
    companyName: payload.companyName || '',
    phone: payload.phone || '',
    personalAddressStreet: payload.personalAddressStreet || '',
    personalAddressCity: payload.personalAddressCity || '',
    personalAddressProvince: payload.personalAddressProvince || '',
    personalAddressPostalCode: payload.personalAddressPostalCode || '',
    personalAddressCountry: payload.personalAddressCountry || '',
    displayName: payload.displayName || '',
    locale: payload.locale === 'en' ? 'en' : 'fr',
    status: 'pending',
    createdAt: new Date(),
  });
}
